import NavHeader from "../shared/Nav-Header";
import { useState, useEffect, useMemo } from "react";
import styles from './channel-profile.module.css';
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Notification from '../../shared/Notification';
import SocialMessageBox from '../../shared/SocialMessageBox';
import defaultProfile2 from '../../images/default-profile2.jpg';
import { GROUPAVATARS } from '../../shared/avatars/GroupAvatars';
// import defaultChannelImage1 from '../../images/channels/channel-1.png';
import defaultChannelImage2 from '../../images/channels/channel-1.png'
import { EditIcon, GroupMessageIcon, CopyLinkIcon,
     LeaveGroupIcon, ReportIcon } from '../../shared/icons/Icons';
import {formatDistanceToNow, set} from 'date-fns';
import { useAuth } from '../../context/AuthContext';
// import SocialSearch from '../../shared/SocialSearch';
                        


const GuestChannelProfile = () => {
    const {channelId} = useParams();
    const [channel, setChannel] = useState();
    const { userId } = useAuth();
    const [activeChannelChat, setActiveChannelChat] = useState(null);
    const [notification, setNotification] = useState('');
    const navigate = useNavigate();
    const [leaveChannelPopup, setLeaveChannelPopup] = useState(false);
    const [deleteChannelPopup, setDeleteChannelPopup] = useState(false);
    const [projectNetworkList, setProjectNetworkList] = useState([]);
    const [showAddMembers, setShowAddMembers] = useState(false);
    const [selectedNetworks, setSelectedNetworks] = useState([]);
    const [availableNetworks, setAvailableNetworks] = useState([]);
    const [createdDate,setCreatedDate] = useState('');
    const [channelProfilePicturePopup, setChannelProfilePicturePopup] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [closeButton,setCloseButton]= useState(false);
    const [selectedAvatar, setSelectedAvatar] = useState(GROUPAVATARS[0]);
    const [editing, setEditing] = useState(false);
    const [channelProfilePictureView, setChannelProfilePictureView] = useState(false);
    const [showOptions, setShowOptions] = useState(null);
    const [membership, setMembership] = useState('');
    // const [leftChannelMembers, setLeftChannelMembers] = useState([])
    // console.log('channel',channel)
    const [reportChannelPopup, setReportChannelPopup] = useState(false);
    const [reportChannelId, setReportChannelId] = useState(null);
    const [reportMessage, setReportMessage] = useState('');
    const token = useMemo(() => localStorage.getItem('token'), []);
    const socialType = 'channel';

    useEffect(() => {
        const fetchChannelDetails = async () => {
            try {
                const response = await axios.get(`/api/guest/social/channel-details/${channelId}`);
                // console.log("Channel Details Response:", response.data.channel);
                setMembership(response.data.membershipStatus);
                setChannel(response.data.channel);
                setCreatedDate(formatDistanceToNow(new Date(response.data.channel.createdAt), {addSuffix: true}))
            }
            catch (error) {
                const errorMessage = error.response?.data?.message || 'Error fetching channel details';
                // console.error(errorMessage);
                setNotification(errorMessage || 'Error fetching channel details. Please try again.');
            }
        };
        fetchChannelDetails();
    }, [membership]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                    navigate('/signup');
                    return;
                }

                const response = await axios.get('/api/guest/pn/my-networks');

                // console.log("response.data", response.data);
                const projectNetworkList = response.data;
                setProjectNetworkList(projectNetworkList);
                setAvailableNetworks(channel ? projectNetworkList.filter(network => !channel.participants.some(participant => participant._id === network._id)) : projectNetworkList);
                // console.log("Available Networks:1", availableNetworks);
                // console.log("channel:1", channel.participants.map(p => p.name));

                // console.log('Project Network List:', projectNetworkList);
            } catch (error) {
                const errorMessage = error.response?.data?.message || 'Error fetching project networks data';
                // console.error(errorMessage);
                setNotification(errorMessage ||'Error fetching project networks data. Please try again.');
            }
        };
        fetchData();
    }, [showAddMembers]);

    // useEffect(() => {
    //     if (membership === 'left') {
    //         const fetchLeftChannelMembers =async() =>{
    //             try {
    //                 const response = await axios.get(`/api/channel/left-channel-members/${channel._id}`, {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem('token')}`
    //                     }
    //                 });
    //                 setLeftChannelMembers(response.data.members);
    //                 // console.log("leftChannelMembers:", response.data.members);
    //             }
    //             catch (error) {
    //                 const errorMessage = error.response?.data?.message || 'Error fetching left channel members data';
    //                 // console.error(errorMessage);
    //                 setNotification('Error fetching left channel members data. Please try again.');
    //             }
    //         }
    //         fetchLeftChannelMembers();
    //     }
    // }, [membership]);

    const handleChannelChatClick = async ( channel) => {
        setNotification(`Please SignUp to Connect to Channels.`);
    };
    const handleLeaveChannelClick = async (channel) => {
        setNotification(`Please SignUp to Leave Channels.`);
    };
    
    const handleDeleteChannelClick = async (channel) => {
        setNotification(`Please SignUp to Delete Channels.`);
        // setDeleteChannelPopup(true);
    };

    const handleAddMembers = async (channelId) => {
        setNotification('Please SignUp to Interact.');
    };
    const handleSelectNetwork = async (event, networkId) => {
        event.stopPropagation();
        setSelectedNetworks((prevSelected) => {
            if (prevSelected.includes(networkId)) {
                return prevSelected.filter(id => id !== networkId);
            } else {
                return [...prevSelected, networkId];
            }
        });
    };

    const handleJoinChannel = async (channelId) => {
        try {
            const response = await axios.post('/api/channel/join-channel', {
                channelId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.data.success) {
                setNotification(response.data.message || 'Joined Channel successfully!');
                setChannel(response.data.channel);
                setMembership('member');
            }
        } catch (error) {
            // console.error('Error joining channel:', error);
            const errorMessage = error.response?.data?.message || 'Error joining channel. Please try again.';
            setNotification(errorMessage);
        }
    };

    const handleRemoveMember = async (channelId, _id) => {
        setNotification(`Please SignUp to Connect to Channels.`)

    };
    const handleLeaveChannel = async (channelId) => {
        setNotification(`Please SignUp to Connect to Channels.`)

    };
    const handleDeleteChannel = async (channelId) => {
        setNotification(`Please SignUp to Connect to Channels.`)

    };

    const confirmDeleteChannel = () => {
        if (channel && channel._id) {
            handleDeleteChannel(channel._id);
        }
        setDeleteChannelPopup(false);
    };
    const cancelDeleteChannel = () => {
        setDeleteChannelPopup(false);
    };

    const handleCloseChat = () => {
        setActiveChannelChat(null);
    };
    const handleCloseNotification = () => {
        setNotification('');
    };

    const confirmLeaveChannel = () => {
        setNotification(`Please SignUp to Connect to Channels.`)

    };
    const cancelLeaveChannel = () => {
        setLeaveChannelPopup(false);
    };

    const handleBack = () => {
        navigate(-1);
    }
    const handleShowAddMembers= () => {
        setNotification(`Please SignUp to Connect to Channels.`)

    };

    const handleSaveChannelInfo = async () => {
        setNotification(`Please SignUp to Connect to Channels.`)

    };
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (editing) {
                event.preventDefault();
                event.returnValue = 'You have unsaved changes. Do you want to leave?';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [editing]);

    const handleChannelProfilePictureClick =() =>{
        // event.stopPropagation(); // यह event को bubble होने से रोकेगा
        setChannelProfilePictureView(!channelProfilePictureView);
    }
    const handleChannelProfilePictureEdit = () => {
        setChannelProfilePicturePopup(!channelProfilePicturePopup);
        setChannelProfilePictureView(false);
    }
    const handleClickOutside = (event) => {
        if (!event.target.closest(`.${styles.top}`) && 
        !event.target.closest(`.${styles.bottom}`)) {
        setChannelProfilePictureView(false);
    }
    };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [channelProfilePictureView]);

    const handleProfilePictureSelect = async (selectedPicture) => {
        setNotification(`Please SignUp to Connect to Channels.`)

    }
    const handleProfileClick = async (networkId) => {
        const profileStatus = 'friends';
        navigate(`/guest/profile/${networkId}`, { state: profileStatus });  
    };

    const handleCopyInviteLink = async (e, channelId) => {
        e.preventDefault();
        e.stopPropagation();
        
        try {
            const response = await axios.post('/api/channel/invite-link', 
                { channelId },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success) {
                const inviteLink = response.data.inviteLink;
                
                await navigator.clipboard.writeText(inviteLink);
                
                const expiresAt = new Date(response.data.expiresAt);
                const now = new Date();
                const daysLeft = Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24));
                
                setNotification(`Invite link copied to clipboard! Valid for ${daysLeft} days.`);
            }
        } catch (err) {
            // console.error('Error generating invite link:', err.message);
            setNotification(err.response?.data?.message || 'Failed to generate invite link. Please try again.');
        }
    };
    
    const handleReportChannel = async (e, channelId) => {
        e.preventDefault();
        e.stopPropagation();            
        setNotification(`Please SignUp to Connect to Channels.`)

    }
    const handleReportChannelPopup = (channelId) => {
        setReportChannelPopup(true);
        setReportChannelId(channelId);
    };
    const cancelReportChannel = () => {
        setReportChannelPopup(false);
    };
    const handleChannelOptions = () => {
        if (showOptions === true) {
            setShowOptions(false);
        } else {
            setShowOptions(true);
        }
    };
    const handleClickOutside2 = (event) => {
            if (!event.target.closest(`.${styles.channelItem}`) && !event.target.closest(`.${styles.messageOptionsMenu}`)) {
                setShowOptions(null);
            }
        };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside2);
        return () => {
            document.removeEventListener('click', handleClickOutside2);
        };
    }, []);
    const handleChange = (e) => {
        // setProfile({ ...profile, [e.target.name]: e.target.value });
    //     setChannel((prevChannel) => ({
        //     ...prevChannel,
        //     profilePicture: selectedPicture
            // }));
    };
    const handleUpload = async (e, type) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'ml_default'); // Replace with your Cloudinary upload preset

        setUploading(true);
        setCloseButton(true);
        try {
            const uploadResponse = await axios.post('/api/upload/upload-all', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            const url = uploadResponse.data.url;

            setChannel((prevChannel) => ({
                ...prevChannel,
                profilePicture: url
            }));

                const response = await axios.post('/api/channel/update-profile-picture', {
                    channelId: channel._id,
                    profilePicture: url
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                //custom upload route
                if (response.data.success) {
                    setNotification(response.data.message || 'Custom profile picture uploaded successfully!');
                    setChannel(response.data.channel);
                }
                
                setUploading(false);
                setCloseButton(false);
                setChannelProfilePicturePopup(false);

            } catch (error) {
                // console.error('Error uploading file:', error);
                const errorMessage = error.response?.data?.message || 'Error uploading file. Please try again.';
                setNotification(errorMessage);
                setUploading(false);
            }
        };
    
    return (
        <div>
            <NavHeader />
            <br/><br/>
            <br/><br/>
            <h1>Channel Profile</h1>
            {notification && (
                    <Notification message={notification} onClose={handleCloseNotification} />
                )}
            {membership == 'member'&&(
                <>
                {channel &&
                    <div className={styles.channelProfileContainer}>
                        <img 
                            title={channel.name} 
                            onClick={()=> handleChannelProfilePictureClick()} 
                            src={channel.profilePicture ? channel.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultChannelImage2}alt="pfp" 
                            className={`${styles.networkProfilePicture} ${styles.top}`} 
                        />
                        {!editing && <h2 className={styles.channelName}>{channel.name}</h2>}
                        
                        <div className={styles.channelItem} onClick={() => {handleChannelOptions()}}>
                            <button 
                                className={styles.threeDotsButton} 
                                 
                                title="options"
                            >
                                ⋮
                            </button>

                            {showOptions === true && (
                                <div className={styles.messageOptionsMenu}>
                                    <button 
                                    onClick={(e) => 
                                    {handleCopyInviteLink(e, channel._id);setShowOptions(null)}}>
                                        <CopyLinkIcon/>
                                        Copy Invite Link
                                    </button>

                                    {membership==='member' && <button 
                                        onClick={() => 
                                        {handleLeaveChannel(channel._id);setShowOptions(null)}}>
                                            <LeaveGroupIcon/>
                                            Leave Channel
                                        </button>
                                    }
                                    <button 
                                    onClick={() => {handleReportChannelPopup(channel._id);setShowOptions(null)}}>
                                        <ReportIcon/>
                                        Report Channel
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className={styles.bottom}>
                            {channelProfilePictureView && (
                                <div className={ styles.channelProfilePictureViewOverlay}>
                                    <h3>{channel.name}</h3>
                                    <img 
                                        title={channel.name} 
                                        src={channel.profilePicture ? channel.profilePicture.replace('/upload/', '/upload/w_288,h_300,c_fill/') : defaultChannelImage2}alt="pfp" 
                                        className={styles.networkProfilePictureLarge} 
                                    />
                                    {channel.admin == userId &&( 
                                    <p onClick={()=>handleChannelProfilePictureEdit()} >
                                        <EditIcon className={styles.editChannelDescriptionIcon}/>
                                    </p>)}
                                    <button onClick={()=>handleChannelProfilePictureClick()} className={styles.closeProfilePictureViewButton}>Close</button>
                                </div>
                            )}  
                        </div>

                            
                        {editing ?
                            (<div className={styles.editDescriptionContainer}>
                                <input
                                type="text"
                                className={styles.channelNameInput}
                                value={channel.name || ""}
                                onChange={(e) => setChannel({ ...channel, name: e.target.value })}
                                placeholder="Enter channel name..."
                            />
                                <textarea
                                    className={styles.descriptionTextarea}
                                    value={channel?.description || ""}
                                    onChange={(e) => setChannel({ ...channel, description: e.target.value })}
                                    placeholder="Enter channel description..."
                                />
                                <div className={styles.descriptionButtons}>
                                    <button 
                                        className={styles.cancelDescriptionButton}
                                        onClick={() => setEditing(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        className={styles.saveDescriptionButton}
                                        onClick={() => {setEditing(false);handleSaveChannelInfo()}}
                                    >
                                        Save
                                    </button>
                                    </div>
                            </div>)
                            :
                            (
                                <>
                                <p className={styles.channelDescription}>{channel.description || "No description Info"}
                                </p>
                                {channel.admin == userId &&( 
                                <p  className={styles.editChannelDescriptionIcon} onClick={()=>setEditing(!editing)} >
                                    <EditIcon/>
                                </p>)}
                                </>
                            )
                        }

                        {channelProfilePicturePopup && (
                                <div>
                                    <h3>Select Avatar</h3>
                                    <div className={styles.profilePictureGrid}>
                                        {GROUPAVATARS.map((defaultChannelImage, index) => (
                                            <img 
                                                key={index}
                                                src={defaultChannelImage} 
                                                alt={`Avatar ${index + 1}`} 
                                                onClick={() => handleProfilePictureSelect(defaultChannelImage)} 
                                                className={styles.gridImage}
                                            />
                                        ))}
                                    </div>

                                    <div className={styles.profileInfo}>
                                        <label>Custom Upload</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'profilePicture')}
                                            className={styles.imageUploadInput}
                                        />
                                        {uploading && <p>Uploading...</p>}
                                    </div>
                                    
                                    <div className={styles.channelProfilePicturePopupCloseButton}>
                                        <button onClick={() => setChannelProfilePicturePopup(false)} disabled={closeButton} className={styles.channelProfilePicturePopupCloseButton}>Close</button>
                                    </div>
                                </div>
                        )}
                        
                        <span className={styles.channelCreated}>Created: {createdDate}</span>
                        <div className={styles.networkActions}>
                            <button onClick={() => handleChannelChatClick(channel)} className={styles.primaryAction}>
                                <GroupMessageIcon /> 
                                <p> Say Hi! </p>
                            </button>
                            <button onClick={() => handleLeaveChannelClick(channel._id)} className={styles.secondaryAction}>
                                😢Leave Channel
                            </button>
                                        <button className={styles.secondaryAction} onClick={() => handleBack()} > Go Back </button>
                            <br/><br/>
                        </div> 
                        
                        <div className={styles.sectionTitle}>
                            <h3 >  </h3>
                            <h3 className={styles.sectionTitleParticipantsNumber}> {channel.participants.length} </h3>
                            <h3 >Members</h3>
                        </div>
                         {/* <SocialSearch socialType="channel" socialId={channelId} /> */}

                        {channel.admin == userId ? (
                            <ul className={styles.memberList}>
                                {channel.participants.map((member, index) => (
                                    <>
                                        <li key={member} className={styles.memberItem} onClick={() => handleProfileClick(member._id)}>
                                            <img title={member.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                        <p>{member.name}</p>
                                            </li>
                                        <button onClick={() => handleRemoveMember(channel._id, member._id)} className={styles.removeMemberButton} aria-label={`Remove ${member.name} from channel`} title="Remove member">
                                            X
                                        </button>
                                    </>
                                ))}
                            </ul>
                            ) : (
                            <ul className={styles.memberList}>
                                {channel.participants.map((member, index) => (
                                    <li key={member._id?.toString()} className={styles.memberItem} onClick={() => handleProfileClick(member._id)}>
                                        <img title={member._id?.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                        <p>{member.name}</p>
                                        </li>
                                ))}
                            </ul>
                        )}

                        {channel.admin == userId ? (
                            <button onClick={handleShowAddMembers} className={styles.addMembers}>
                                Add Members
                            </button>
                        ) : null}

                        {showAddMembers && (
                            <div className={styles.mainContent}>
                                <div className={styles.leftColumn}>
                                    <div className={styles.channelCreationForm}>
                                        <h4>🌈 Adding {selectedNetworks.length} New Member(s) to {channel.name}🌈</h4>
                                        <button onClick={()=>handleAddMembers(channel._id)} className={styles.createButton}>
                                            🎊 Add Selected Members! 🎊
                                        </button>
                                        <button onClick={handleShowAddMembers} className={styles.closeCreateChannelButton}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                                <div className={styles.rightColumn}>
                                    {(availableNetworks || availableNetworks.length !== 0) &&  (
                                        <div className={`${styles.networksSection} ${styles.pnChannel}`}>
                                            <h3>Add Friends</h3>
                                            <ul>
                                                {availableNetworks?.map(network => (
                                                    <li key={network._id} className={styles.networkItem} 
                                                    onClick={(e) => handleSelectNetwork(e, network._id)}
                                                    >
                                                        <div className={styles.networkInfo} >
                                                            <img title={network.name} src={network.profilePicture ? network.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                                            <span className={styles.networkName}>💫 {network.name} 💫</span>
                                                            <span className={styles.connectionTime}>{network.skills}</span>
                                                            <input type="checkbox" checked={selectedNetworks.includes(network._id)}/>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            {(!availableNetworks || availableNetworks.length === 0) && (
                                            <div className={styles.emptyState}>
                                                <p>🥺All Your Connection are in this channel? Let's find some amazing people to connect with! 🥺</p>
                                            </div> 
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        
                    </div>
                }
                {leaveChannelPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popupContent}>
                            <h2>Confirm Leave Channel</h2>
                            <p>Are you sure you want to leave this channel?</p>
                            <div className={styles.popupActions}>
                                <button onClick={confirmLeaveChannel} className={styles.confirmButton}>Yes, Leave</button>
                                <button onClick={cancelLeaveChannel} className={styles.cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
                {activeChannelChat && (
                    <SocialMessageBox socialType={socialType} social={activeChannelChat} onClose={handleCloseChat} /> 
                )}
                </>
            )}
            {membership == 'guest'&&(
                <>
                {channel &&
                    <div className={styles.channelProfileContainer}>
                        <img 
                            title={channel.name} 
                            onClick={()=> handleChannelProfilePictureClick()} 
                            src={channel.profilePicture ? channel.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultChannelImage2}alt="pfp" 
                            className={`${styles.networkProfilePicture} ${styles.top}`} 
                        />
                        <div className={styles.channelItem} onClick={() => {handleChannelOptions()}}>
                            <button 
                                className={styles.threeDotsButton} 
                                title="options"
                            >
                                ⋮
                            </button>
                            {showOptions === true && (
                                <div className={styles.messageOptionsMenu}>
                                    <button 
                                    onClick={(e) => 
                                    {handleCopyInviteLink(e, channel._id);setShowOptions(null)}}>
                                        <CopyLinkIcon/>
                                        Copy Invite Link
                                    </button>
                                    <button 
                                    onClick={() => {handleReportChannelPopup(channel._id);setShowOptions(null)}}>
                                        <ReportIcon/>
                                        Report Channel
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className={styles.bottom}>
                            {channelProfilePictureView && (
                                <div className={ styles.channelProfilePictureViewOverlay}>
                                    <h3>{channel.name}</h3>
                                    <img 
                                        title={channel.name} 
                                        src={channel.profilePicture ? channel.profilePicture.replace('/upload/', '/upload/w_288,h_300,c_fill/') : defaultChannelImage2}alt="pfp" 
                                        className={styles.networkProfilePictureLarge} 
                                    />
                                    <button onClick={()=>handleChannelProfilePictureClick()} className={styles.closeProfilePictureViewButton}>Close</button>
                                </div>
                            )}  
                        </div>

                        <p className={styles.channelDescription}>{channel.description || "No description Info"}</p>
                        <span className={styles.channelCreated}>Created: {createdDate}</span>
                        <div className={styles.networkActions}>
                            <button onClick={() => handleJoinChannel(channel._id)} className={styles.primaryAction}>
                                <p> Join Channel </p>
                            </button>
                            <button className={styles.secondaryAction} onClick={() => handleBack()} > Go Back </button>
                            <br/><br/>
                        </div> 
                        
                        <div className={styles.sectionTitle}>
                            <h3 >  </h3>
                            <h3 className={styles.sectionTitleParticipantsNumber}> {channel.participants.length} </h3>
                            <h3 >Members</h3>
                        </div>

                        <ul className={styles.memberList}>
                            {channel.participants.map((member, index) => (
                                <li key={member._id?.toString()} className={styles.memberItem} onClick={() => handleProfileClick(member._id)}>
                                    <img title={member._id?.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                    <p>{member.name}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                }

                {leaveChannelPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popupContent}>
                            <h2>Confirm Leave Channel</h2>
                            <p>Are you sure you want to leave this channel?</p>
                            <div className={styles.popupActions}>
                                <button onClick={confirmLeaveChannel} className={styles.confirmButton}>Yes, Leave</button>
                                <button onClick={cancelLeaveChannel} className={styles.cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
                {/* {activeChannelChat && (
                    <SocialMessageBox socialType={socialType} social={activeChannelChat} onClose={handleCloseChat} /> 
                )} */}
                </>
            )}
            {membership == 'left'&&(
                <>
                {channel &&
                    <div className={styles.channelProfileContainer}>
                        <img 
                            title={channel.name} 
                            onClick={()=> handleChannelProfilePictureClick()} 
                            src={channel.profilePicture ? channel.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultChannelImage2}alt="pfp" 
                            className={`${styles.networkProfilePicture} ${styles.top}`} 
                        />
                        <h2 className={styles.channelName}>{channel.name}</h2>
                        
                        <div className={styles.channelItem} onClick={() => {handleChannelOptions()}}>
                            <button 
                                className={styles.threeDotsButton} 
                                 
                                title="options"
                            >
                                ⋮
                            </button>

                            {showOptions === true && (
                                <div className={styles.messageOptionsMenu}>
                                    <button 
                                    onClick={(e) => 
                                    {handleCopyInviteLink(e, channel._id);setShowOptions(null)}}>
                                        <CopyLinkIcon/>
                                        Copy Invite Link
                                    </button>
                                    <button 
                                    onClick={() => {handleDeleteChannelClick(channel._id);setShowOptions(null)}}>
                                        <ReportIcon/>
                                        Delete Channel
                                    </button>
                                    <button 
                                    onClick={() => {handleReportChannelPopup(channel._id);setShowOptions(null)}}>
                                        <ReportIcon/>
                                        Report Channel
                                    </button>
                                </div>
                            )}
                            </div>
                        <div className={styles.bottom}>
                            {channelProfilePictureView && (
                                <div className={ styles.channelProfilePictureViewOverlay}>
                                    <h3>{channel.name}</h3>
                                    <img 
                                        title={channel.name} 
                                        src={channel.profilePicture ? channel.profilePicture.replace('/upload/', '/upload/w_288,h_300,c_fill/') : defaultChannelImage2}alt="pfp" 
                                        className={styles.networkProfilePictureLarge} 
                                    />
                                    <button onClick={()=>handleChannelProfilePictureClick()} className={styles.closeProfilePictureViewButton}>Close</button>
                                </div>
                            )}  
                        </div>

                        <p className={styles.channelDescription}>{channel.description || "No description Info"}
                        </p>
                        
                        <span className={styles.channelCreated}>Created: {createdDate}</span>
                        <div className={styles.networkActions}>
                            <button onClick={() => handleJoinChannel(channel._id)} className={styles.primaryAction}>
                                Rejoin Channel
                            </button>
                            <button className={styles.secondaryAction} onClick={() => handleBack()} > Go Back </button>
                            <br/><br/>
                        </div> 
                        
                        <div className={styles.sectionTitle}>
                            <h3 >  </h3>
                            <h3 className={styles.sectionTitleParticipantsNumber}> {channel.participants.length} </h3>
                            <h3 >Members</h3>
                        </div>

                        <ul className={styles.memberList}>
                            {channel.participants.map((member, index) => (
                                <li key={member._id?.toString()} className={styles.memberItem} onClick={() => handleProfileClick(member._id)}>
                                    <img title={member._id?.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                    <p>{member.name}</p>
                                </li>
                            ))}
                        </ul>
                            
                    </div>
                }
                {deleteChannelPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popupContent}>
                            <h2>Confirm Delete Channel</h2>
                            <p>Are you sure you want to delete this channel?</p>
                            <div className={styles.popupActions}>
                                <button onClick={confirmDeleteChannel} className={styles.confirmButton}>Yes, Delete</button>
                                <button onClick={cancelDeleteChannel} className={styles.cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
                {/* {activeChannelChat && (
                    <SocialMessageBox socialType={socialType} social={activeChannelChat} onClose={handleCloseChat} /> 
                )} */}
                </>
            )}
            {reportChannelPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popupContent}>
                            <h2>Reporting Channel</h2>
                            <p>Thanks, Reported Channel are reviewed shortly.</p>
                                <textArea
                                    type="text"
                                    value={reportMessage}
                                    onChange={(e) => setReportMessage(e.target.value)}
                                    placeholder="Report Message (Optional)"
                                    className={styles.reportMessageInput}
                                />
                            <div className={styles.popupActions}>
                                <button onClick={(e)=>handleReportChannel(e, reportChannelId)} className={styles.confirmButton}>Report</button>
                                <button onClick={cancelReportChannel} className={styles.cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
        </div>
    );
}
export default GuestChannelProfile;